const backToTopButton = () => {
    const classes = {
        showBackToTopButton: 'back-to-top-button--visible',
    };
    const selectors = {
        backToTopButton: '[data-back-to-top-button]',
    };
    const backToTopButton = document.querySelector(selectors.backToTopButton);
    if (backToTopButton) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 500) {
                backToTopButton.classList.add(classes.showBackToTopButton);
            }
            else {
                backToTopButton.classList.remove(classes.showBackToTopButton);
            }
        });
        backToTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }
};
export { backToTopButton };
